const Fonts = {
  regular: "Roboto_400Regular",
  bold: "Roboto_700Bold",
};

export default Fonts;
